module.exports = require("http");


/*****************
 ** WEBPACK FOOTER
 ** external "http"
 ** module id = 249
 ** module chunks = 0
 **/